<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <b-row>
        <b-colxx xxs="12">
          <!-- <h1>{{ $t("menu.data-list") }}</h1> -->
          <h1><i class="iconsminds-assistant mr-2"></i>Les Assistants</h1>
          <div class="top-right-button-container">
            <b-button @click="addItem" v-b-modal.modalright variant="primary" size="lg" class="top-right-button"
              ref="openModal">
              Ajouter
            </b-button>

            <b-modal id="modalright" ref="modalright" :title="isEdit ? 'Editer un Assistant' : 'Ajouter un Assistant'"
              class="modal-right">
              <b-form>
                <b-form-group :label="'Nom Complet'">
                  <b-form-input v-model="newUser.name" />
                </b-form-group>
                <b-form-group :label="'CIN'">
                  <b-form-input v-model="newUser.cin" />
                </b-form-group>
                <b-form-group :label="'Email'">
                  <b-form-input v-model="newUser.email" />
                </b-form-group>
                <b-form-group :label="'Telephone'">
                  <b-form-input v-model="newUser.phone" />
                </b-form-group>
                <b-form-group :label="'Assurance'">
                  <b-form-input v-model="newUser.mituel" />
                </b-form-group>

                <b-form-group :label="'Adresse'">
                  <b-form-input v-model="newUser.adresse" />
                </b-form-group>
                <b-form-group :label="'Genre'">
                  <!-- <b-form-input v-model="newUser.gender" /> -->
                  <b-radio name="masculin" value="masculin" class="mb-3" v-model="newUser.gender">
                    Masculin
                  </b-radio>

                  <b-radio name="féminin" value="féminin" class="mb-3" v-model="newUser.gender">
                    Féminin
                  </b-radio>
                </b-form-group>
                <b-form-group :label="'Date de Naissance'">
                  <b-form-input v-model="newUser.birthdate" />
                </b-form-group>
              </b-form>

              <template slot="modal-footer">
                <b-button variant="outline-secondary" @click="hideModal('modalright')">Annuler</b-button>
                <b-button variant="primary" @click="addNewItem()" class="mr-1">Confirmer</b-button>
              </template>
            </b-modal>
          </div>

          <div class="mb-2 mt-2">
            <b-button variant="empty" class="pt-0 pl-0 d-inline-block d-md-none" v-b-toggle.displayOptions>
              {{ $t("pages.display-options") }}
              <i class="simple-icon-arrow-down align-middle" />
            </b-button>
          </div>
          <div class="separator mb-5" />
        </b-colxx>
      </b-row>
      <template v-if="isLoad">
        <label class="form-group has-float-label" v-if="listAssistants.length">
          <input placeholder="Filtrer par Nom ou CIN ou Telepohne" type="text" class="form-control"
            v-model="searchText" />
          <span>Rechercher</span>
        </label>
        <b-row v-if="displayMode === 'thumb'" key="thumb">
          <b-colxx xxs="12" class="mb-3" v-for="(item, index) in filtredAssistants" :key="index" :id="item.id">
            <data-list-item :key="item.id" :data="item" @edit="editAssistant($event, item.id)"
              @delete="deleteAssistant($event, item.id)" @reset="resetAssistantPass($event, item.id)" />
          </b-colxx>
          <b-colxx xxs="12" class="mb-3" v-if="assistantsPage">
            <b-button v-if="!loadingMore" @click="getMoreAssistants()" type="button" variant="primary" size="lg"
              class="w-100" :disabled="false">Charger Plus</b-button>
            <b-button v-else disabled variant="primary" size="lg" class="w-100">
              <div class="span w-100">
                <div class="typing_loader"></div>
              </div>
            </b-button>
          </b-colxx>
        </b-row>
        <b-card class="w-100" v-if="!filtredAssistants.length" no-body>
          <b-card-body class="text-center p-4">
            <h5 class="card-title mb-0">Aucun assistant trouvé.</h5>
          </b-card-body>
        </b-card>
      </template>
      <template v-else>
        <div class="loading"></div>
      </template>
    </b-colxx>
  </b-row>
</template>
<script>
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import "bootstrap";
import bootbox from "bootbox";
import DataListItem from "@/components/Listing/AssistantListItem";
import { apiUrl } from "@/constants/config";
export default {
  name: "assistants",
  components: {
    DataListItem,
  },
  data() {
    return {
      isLoad: false,
      apiBase: apiUrl,
      currentAssistant: null,
      isEdit: false,
      displayMode: "thumb",
      listAssistants: [],
      newUser: {
        name: "",
        cin: "",
        email: "",
        phone: "",
        mituel: "",
        adresse: "",
        gender: "",
        birthdate: ""
      },
      searchText: "",
      assistantsPage: null,
      loadingMore: false,
    };
  },
  methods: {
    isValidAssistant() {
      const schema = this.$joi.object({
        name: this.$joi.string().min(3),
        cin: this.$joi.string().alphanum().min(3),
        email: this.$joi
          .string()
          .email({
            minDomainSegments: 2,
            tlds: { allow: ["com", "net", "fr", "ma"] },
          }),
        phone: this.$joi.string().alphanum().min(8),
        adresse: this.$joi.string().min(5),
        gender: this.$joi.string().min(3),
      });
      let name = schema.validate({ name: this.newUser.name });
      let cin = schema.validate({ cin: this.newUser.cin });
      let email = schema.validate({ email: this.newUser.email });
      let phone = schema.validate({ phone: this.newUser.phone });
      let adresse = schema.validate({ adresse: this.newUser.adresse });
      let gender = schema.validate({ gender: this.newUser.gender });
      if (name.error) {
        this.$notify("error filled", "", "Le format du nom est invalide.", {
          duration: 5000,
          permanent: false,
        });
        return false;
      } else if (cin.error) {
        this.$notify("error filled", "", "Le format du cin est invalide.", {
          duration: 5000,
          permanent: false,
        });
        return false;
      } else if (phone.error) {
        this.$notify(
          "error filled",
          "",
          "Le format du Numéro de Téléphone est invalide.",
          { duration: 5000, permanent: false }
        );
        return false;
      } else if (adresse.error) {
        this.$notify(
          "error filled",
          "",
          "Le format d'Adresse postale est invalide.",
          { duration: 5000, permanent: false }
        );
        return false;
      } else if (gender.error) {
        this.$notify(
          "error filled",
          "",
          "Genre non selectionné! , Merci de selectionner un genre.",
          { duration: 5000, permanent: false }
        );
        return false;
      } else {
        if (this.newUser.email == "") {
          return true;
        } else {
          if (email.error) {
            this.$notify(
              "error filled",
              "",
              "Le format d'email est invalide.",
              { duration: 5000, permanent: false }
            );
            return false;
          } else {
            return true;
          }
        }
      }
      console.log("name", name);
      console.log("cin", cin);
      console.log("email", email);
      // return false
    },
    addItem() {
      this.currentAssistant = null;
      this.newUser = {
        name: "",
        cin: "",
        email: "",
        phone: "",
        mituel: "",
        adresse: "",
        gender: "",
        birthdate: ""
      };
      this.isEdit = false;
    },
    getMoreAssistants() {
      this.loadingMore = true;
      let page = this.assistantsPage;
      this.sendRequest("get", this.currentEndpoint + "/page/" + page)
        .then((res) => {
          console.log("reees", res);
          this.listAssistants = [...this.listAssistants, ...res.data.data];
          this.assistantsPage = res.data.next;
          this.loadingMore = false;
        })
        .catch((err) => {
          this.loadingMore = false;
          console.log("iam the error", err);
        });
    },
    getAssistants() {
      this.isLoad = false;
      let page = this.assistantsPage ? this.assistantsPage : 1;
      this.sendRequest("get", this.currentEndpoint + "/page/" + page)
        .then((res) => {
          console.log("reees", res);
          this.listAssistants = res.data.data;
          this.assistantsPage = res.data.next;
          this.isLoad = true;
        })
        .catch((err) => {
          this.isLoad = true;
          console.log("iam the error", err);
        });
    },
    hideModal(refname) {
      this.$refs[refname].hide();
      this.currentAssistant = null;
      this.newUser = {
        name: "",
        cin: "",
        email: "",
        phone: "",
        mituel: "",
        adresse: "",
        gender: "",
        birthdate: ""
      };
      this.isEdit = false;
    },
    changeDisplayMode(displayType) {
      this.displayMode = displayType;
    },
    addNewItem() {
      if (this.isValidAssistant()) {
        let obj = {
          name: this.newUser.name,
          cin: this.newUser.cin,
          email: this.newUser.email,
          phone: this.newUser.phone,
          mituel: this.newUser.mituel,
          adresse: this.newUser.adresse,
          gender: this.newUser.gender,
          birthdate: this.newUser.birthdate
        };
        if (this.isEdit) {
          this.sendRequest(
            "put",
            this.currentEndpoint + `/id/${this.currentAssistant.id}`,
            obj
          )
            .then((res) => {
              if (res.status == 200) {
                let idx = this.listAssistants.findIndex(
                  (ob) => ob.id == this.currentAssistant.id
                );
                if (idx !== -1) {
                  (this.listAssistants[idx].name = this.newUser.name),
                    (this.listAssistants[idx].cin = this.newUser.cin),
                    (this.listAssistants[idx].email = this.newUser.email),
                    (this.listAssistants[idx].phone = this.newUser.phone),
                    (this.listAssistants[idx].mituel = this.newUser.mituel);
                  this.listAssistants[idx].adresse = this.newUser.adresse;
                  this.listAssistants[idx].gender = this.newUser.gender;
                  this.listAssistants[idx].birthdate = this.newUser.birthdate;
                }
                this.hideModal("modalright");
              }
            })
            .catch((err) => {
              this.isLoad = true;
            });
        } else {
          this.sendRequest("post", this.currentEndpoint, obj)
            .then((res) => {
              if (res.status == 200) {
                this.listAssistants.push(res.data);
                this.hideModal("modalright");
              }
            })
            .catch((err) => {
              this.isLoad = true;
            });
        }
      }
    },
    editAssistant(event, id) {
      let index = this.listAssistants.findIndex((obj) => obj.id == id);
      let item = this.listAssistants[index];
      this.currentAssistant = item;
      this.isEdit = event;
      this.newUser.name = item.name;
      this.newUser.cin = item.cin;
      this.newUser.email = item.email;
      this.newUser.phone = item.phone;
      this.newUser.mituel = item.mituel;
      this.newUser.adresse = item.adresse;
      this.newUser.gender = item.gender;
      this.newUser.birthdate = item.birthdate;
      this.$refs.modalright.show();
    },
    deleteAssistant(event, id) {
      let index = this.listAssistants.findIndex((obj) => obj.id == id);
      let item = this.listAssistants[index];
      bootbox.confirm({
        message: "Etes vous Sur ?",
        locale: "fr",
        callback: (result) => {
          if (result) {
            this.deleteCurrentAssistant(item.id, index);
          }
        },
      });
    },
    deleteCurrentAssistant(id, index) {
      this.sendRequest("delete", this.currentEndpoint + `/id/${id}`)
        .then((res) => {
          if (res.status == 200) {
            this.listAssistants.splice(index);
          }
        })
        .catch((err) => {
          this.isLoad = true;
        });
    },
    resetAssistantPass(event, id) {
      bootbox.confirm({
        message:
          "Etes vous Sur de réinitialier le mot de passe a '123456789' ?",
        locale: "fr",
        callback: (result) => {
          if (result) {
            this.sendRequest(
              "put",
              this.currentEndpoint + `/id/${id}/password/reset`
            )
              .then((res) => {
                if (res.status == 200) {
                  this.$notify(
                    "success filled",
                    "",
                    "Mot de passe réinitialisé avec succes.",
                    { duration: 5000, permanent: false }
                  );
                }
              })
              .catch((err) => {
                // this.isLoad = true;
              });
          }
        },
      });
    },
  },
  computed: {
    currentEndpoint() {
      return `${this.apiBase}/assistants`;
    },
    filtredAssistants() {
      if (!this.listAssistants.length) {
        return [];
      }
      return this.listAssistants.filter((res) => {
        return (
          res.email.toLowerCase().includes(this.searchText.toLowerCase()) ||
          res.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
          res.phone.toLowerCase().includes(this.searchText.toLowerCase()) ||
          res.cin.toLowerCase().includes(this.searchText.toLowerCase())
        );
      });
    },
  },
  watch: {
    currentEndpoint() {
      this.getAssistants();
    },
  },
  mounted() {
    this.getAssistants();
  },
};
</script>
<style lang="scss">
.bootbox {
  .modal-dialog {
    .modal-content {
      .modal-footer {
        padding: 15px;
      }
    }
  }
}

.typing_loader {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  -webkit-animation: typing 1s linear infinite alternate;
  -moz-animation: Typing 1s linear infinite alternate;
  animation: typing 1s linear infinite alternate;
  margin: 10px auto;
  /* Not necessary- its only for layouting*/
  position: relative;
  left: -12px;
}

@-webkit-keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}

@-moz-keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}

@keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}
</style>
